"use client"
import { WhiteLogo } from "@/assets/logos";
import { ArrowRightIcon } from "@/components/icons";
import { SystemLanguages } from "@/data/enums";
import { filledIconButtonStyle } from "@/data/styles";
import { RecursiveTranslations } from "@/data/types";
import SubtileShine from "../SubtileShine";
import Link from "next/link";
import { useState } from "react";
import { subToNewsletter } from "@/utils/api";
import Toast from "../toast/Toast";

export default function LogoNewsletterSegment({ translations, lang }: { translations: RecursiveTranslations, lang: SystemLanguages }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | undefined>(undefined);
  const [messageStatus, setMessageStatus] = useState<"success" | "error" | undefined>(undefined);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(undefined);
    setMessageStatus(undefined);

    try {
      const res = await subToNewsletter({ email });
      setMessage(res.message || "Subscribed successfully!");
      setMessageStatus("success");
      setEmail(""); // reset input

      setTimeout(() => { setMessage(undefined); setMessageStatus(undefined); }, 4000);
    } catch (err) {
      setMessage("Failed to subscribe. Please try again.");
      setMessageStatus("error");

      setTimeout(() => { setMessage(undefined); setMessageStatus(undefined); }, 4000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col max-w-[416px]">
      <WhiteLogo className="mb-[30px] w-[187px] h-[89px]" />

      <div className="flex flex-col">
        <p className="leading-[30px] text-[18px] font-normal mb-[10px]">{translations?.newsletterText as string}</p>
      
        <form onSubmit={handleSubmit} className="flex flex-row gap-[12px] mb-[15px]">
          <input
            type="email" value={email} onChange={handleChange} required
            placeholder={translations?.emailPlaceholder as string}
            className="bg-[#F6F6F1] border-0 px-[12px] py-[17px] rounded-[8px] text-[#565E59] text-[14px] w-full focus:outline-none"
          />

          <button type="submit" disabled={loading} aria-label="newsletter-register-btn">
            <div className="relative inline-block">
              <ArrowRightIcon width={20} height={20} color="white" className={filledIconButtonStyle} />
              <SubtileShine />
            </div>
          </button>
        </form>

        <p className="text-[12px] leading-[16px] font-normal">
          {(translations.agreement as Record<string, string>)?.prefix}{" "}
          <Link href={`/${lang}/terms-and-conditions`} className="underline">
            {(translations.agreement as Record<string, string>)?.terms}
          </Link>{" "}
          {(translations.agreement as Record<string, string>)?.and}{" "}
          <Link href={`/${lang}/privacy-policy`} className="underline">
            {(translations.agreement as Record<string, string>)?.privacy}
          </Link>{" "}
        </p>
      </div>

      <Toast 
        status={messageStatus} 
        message={message} 
        onClose={() => { setMessage(undefined); setMessageStatus(undefined); }} 
      />
    </div>
  )
}